import { render, staticRenderFns } from "./CreateTax.vue?vue&type=template&id=598fb0b4"
import script from "./CreateTax.vue?vue&type=script&lang=js"
export * from "./CreateTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports